<template>
  <div class="courses-list-skeleton" aria-hidden="true">
    <div class="skeleton-back-row">
      <div class="skeleton-button" />
      <div class="skeleton-filter" />
    </div>
    <div class="courses-grid">
      <CourseCardSkeleton
        v-for="i in cardCount"
        :key="i"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{ cardCount?: number }>(),
  { cardCount: 12 }
)
</script>

<style scoped>
.courses-list-skeleton {
  width: 100%;
  max-width: var(--max-width-container);
  margin: 0 auto;
}

.skeleton-back-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
}

.skeleton-button {
  width: 180px;
  height: 52px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton-filter {
  width: 200px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
  animation-delay: 0.15s;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 25px;
  margin-bottom: 2rem;
  min-width: 0;
}

@media (max-width: 1024px) {
  .courses-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .courses-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .skeleton-back-row {
    flex-direction: column;
    align-items: stretch;
  }

  .skeleton-button {
    width: 100%;
  }

  .skeleton-filter {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .courses-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@keyframes skeleton-shimmer {
  to {
    background-position: 200% 0;
  }
}
</style>
